module.exports = __webpack_public_path__ + "img/20190911163702360截图20190911141100407.2067996a.jpg";